export const UNIQUE_COUNT_METRIC = 'unique_count' as const;
export const TOTAL_COUNT_METRIC = 'total_count' as const;
